import List from './List';
import Save from './Save';

export default {
  List,
  Save,
};
